import { render, staticRenderFns } from "./PedidosLista.vue?vue&type=template&id=68f48f9d&scoped=true&"
import script from "./PedidosLista.vue?vue&type=script&lang=js&"
export * from "./PedidosLista.vue?vue&type=script&lang=js&"
import style0 from "./PedidosLista.vue?vue&type=style&index=0&id=68f48f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f48f9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
